import { render } from "./stripe-onboard.vue?vue&type=template&id=4515aa83&scoped=true"
import script from "./stripe-onboard.vue?vue&type=script&lang=js"
export * from "./stripe-onboard.vue?vue&type=script&lang=js"

import "./stripe-onboard.vue?vue&type=style&index=0&id=4515aa83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4515aa83"]])

export default __exports__